module.exports = __webpack_public_path__ + "static/img/product-banner.f66e9e26.png";